<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Возврат товаров и услуг</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / Возврат /</span> Возврат товаров и услуг</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <div class="column" style="padding-top: 20px !important;">
                    <VueDatePicker
                        no-title
                        no-header
                        range
                        :rangeInputText="date.start === date.end ? '%d' : '%d - %d'"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="date"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                          {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="column mt-5">
                    {{ client.name }}
                  </div>

                  <v-data-table
                      :headers="headersReturn"
                      :items="(newList && newList.length > 0) ? newList : (products ? products.products : [])"
                      item-key="buy_id"
                      no-data-text="Ничего не найдено"
                      hide-default-footer
                      class="elevation-1 mt-5 custom__table"
                  >
                    <template v-slot:item.buy_name="{item}">
                      <router-link :to="{name: 'ReturnServiceDetail', params: {client: client, buy: item, date: date}}">
                        {{ item.buy_name }}
                      </router-link>
                    </template>
                    <template v-slot:item.sum="{item}">
                      {{ item.sum }} ₽
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {returnActionTypes} from '@/store/modules/return';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "ReturnService",
  props: ['client','buy','datebuy'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    ...mapState({
      products: state => state.refund.products
    })
  },
  data() {
    return {
      date: new Date(),
      headersReturn: [
        {text: 'Дата', align: 'start', sortable: false, value: 'date', width: '15%'},
        {text: 'Товары и услуги', align: 'start', value: 'buy_name', width: '70%'},
        {text: 'Сумма для возврата', align: 'start', value: 'sum', width: '15%'},
      ],
      newList:[]
    }
  },
  methods: {
    fetchFeed(client_id, date) {
      this.$store.dispatch(returnActionTypes.getReturnProducts, {
        client_id,
        startdate: date,
        enddate: date
      }).then((response) => {
        if(this.products) {
          console.log(this.products)
          if(this.buy && this.buy.id){
            console.log('yes')
            for(let i = 0; i < this.products.products.length; i++){
              if(this.products.products[i].buy_id === this.buy.id){
                console.log('yes2')
                //this.products[i].actual = true
                this.newList.push(this.products.products[i])
              } 
            }
          }


        }
      })
    }
  },
  mounted() {
    this.client !== undefined ? setItem('return-client',JSON.stringify(this.client)) : this.client = this.client = JSON.parse(getItem('return-client'));
    console.log(this.datebuy)
    console.log(this.buy)
    console.log(this.client)
    if(this.client && this.client.first_name) {
      this.client.name = this.client.last_name + ' ' + this.client.first_name
      this.client.id = this.client.client_id
    }

    let datFind = this.date

    if(this.datebuy){
      datFind = this.datebuy
    }

    this.fetchFeed(this.client.client_id, datFind);
  },
  watch: {
    date() {
      this.$store.dispatch(returnActionTypes.getReturnProducts, {
        client_id: this.client.client_id,
        date: this.date.start === this.date.end ? this.date.start : null,
        startdate: this.date.start,
        enddate: this.date.end
      })
    }
  }
}
</script>

<style scoped>
.custom__button {
  width: 250px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 250px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.column {
  display: flex;
  justify-content: center;
  width: 100%;
}

.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}
</style>